import { useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Books from './components/Books';
import Blog from './components/Blog';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <About />
      <Books />
      <Blog />
      <Contact />
      <Footer />
    </div>
  );
}